import { render, staticRenderFns } from "./detaliPageConRoom.vue?vue&type=template&id=13c17c58&scoped=true"
import script from "./detaliPageConRoom.vue?vue&type=script&lang=js"
export * from "./detaliPageConRoom.vue?vue&type=script&lang=js"
import style0 from "./detaliPageConRoom.vue?vue&type=style&index=0&id=13c17c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c17c58",
  null
  
)

export default component.exports